import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    /* Registro de bancos */
    cancelacionesMotivos: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',
    incluirInactivos: false,
    
    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.cancelacionesMotivos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR'(state) {
        state.cancelacionesMotivos = [];
    },
    'SET_CANCELACIONES_MOTIVOS'(state, cancelacionesMotivos) {
        state.cancelacionesMotivos = cancelacionesMotivos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, params) {
        state.list = params.list;
        state.selectList = params.selectList;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getCancelacionesMotivos: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }
            if ((/true/i).test(state.incluirInactivos)) {
                queryString += '&incluirInactivos= true';
            }

            apiAxios.get('cancelacionesmotivos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_CANCELACIONES_MOTIVOS', res.data)

                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },
    getList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('cancelacionesmotivos/list')
                .then(res => {
                    let list = res.data.map(cancelacionMotivo => {
                        return cancelacionMotivo.nombre.trim()
                    })
                    let params = {
                        list: res.data,
                        selectList: list
                    }
                    commit('SET_LIST', params);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}